// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"style_tooltip__35wWk","value":"style_value__2ZKKD"};